import config from 'config'

// @todo Since we have required domain
// we can change this code snippet
export const getWidgetCode = options => (
  `<script type="text/javascript">!function(d){var s=d.createElement('script');s.src='${config.widgetLauncherURL}';s.onload=function(){window.indemandly = new Indemandly(${JSON.stringify(options)});};var c=d.getElementsByTagName('script')[0];c.parentNode.insertBefore(s,c);}(document)</script>`
)

export const getWidgetURL = domain => (
  `${config.widgetPageURL.replace(/\[DOMAIN\]/i, domain)}`
)

export const getWidgetDefaultColor = () => '#41b2fd'
